import React from 'react';
import { Mail, Phone } from 'lucide-react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';

function ContactAdmissions({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  return (
    <section className="py-16 bg-white">
      <div className="container-page">
        <Reveal>
          <div className="card-surface p-6 bg-gradient-to-br from-olive-light to-white max-w-xl">
            <h3 className="font-display text-xl">
              <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
            </h3>
            <div className="mt-4 space-y-3 text-sm">
              <div className="flex items-center gap-3"><Mail size={16} className="text-olive" /> <EditableText value={data.email} onChange={(t) => update({ email: t })} as="span" /></div>
              <div className="flex items-center gap-3"><Phone size={16} className="text-olive" /> <EditableText value={data.phone} onChange={(t) => update({ phone: t })} as="span" /></div>
              <EditableText value={data.hours} onChange={(t) => update({ hours: t })} as="p" multiline className="text-ink/60 text-xs mt-3" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default ContactAdmissions;
